import React, { PropsWithChildren } from 'react';

/**
 * Column in a form. Is mainly used within FormRow.
 * Can contain nodes, elements and Strings as children.
 */
export default function FormsColumn(props: PropsWithChildren<unknown>) {
  return <div className="form-column">{props.children}</div>;
}
